import {
  useCheckSavedProfileExists,
  useCreateSavedProfileFromVault,
  useUpdateSavedProfileFromVault,
} from "@equidefi/portals/hooks/useSavedProfiles";

export const useSavedProfileUpsert = (vaultId: string, accountType: string) => {
  const { data: profileExists, isFetching: isCheckingExists } = useCheckSavedProfileExists(accountType, {
    enabled: !!accountType,
  });

  const createProfile = useCreateSavedProfileFromVault(vaultId);
  const updateProfile = useUpdateSavedProfileFromVault(vaultId);

  const isSaving = createProfile.isLoading || updateProfile.isLoading;
  const isReady = !isCheckingExists;

  const upsertProfile = async () => {
    if (profileExists?.exists) {
      await updateProfile.mutateAsync();
    } else {
      await createProfile.mutateAsync();
    }
  };

  return { upsertProfile, isSaving, profileExists, isReady };
};
